module.exports = __webpack_public_path__ + "img/page10_text.bb7a5055.png";